import { PointcloudStatus } from './enums';
import type { Pointcloud } from './generated';
import { UnreachableCaseError } from 'ts-essentials';

type PointcloudStatusDto = NonNullable<Pointcloud['status']>;

export function mapToPointcloudStatus(
  status: PointcloudStatusDto
): PointcloudStatus {
  switch (status) {
    case 'Initializing':
    case 'InProgress':
      return PointcloudStatus.Processing;

    case 'Ready':
      return PointcloudStatus.Ready;

    case 'Failed':
      return PointcloudStatus.Failed;

    default:
      throw new UnreachableCaseError(status);
  }
}
